module.exports = __webpack_public_path__ + "/static/assets/424371873bc8df88d6a305d8727157ab.svg";